module.exports = __webpack_public_path__ + "media/images/smart_phone/btn_login-e4211eec8b4135e231d9932803053d91.png";